module.exports = __webpack_public_path__ + "img/login-bg.d42fe0b1.png";